if (typeof window.minutosScriptLoaded === 'undefined') {

    window.minutosScriptLoaded = true;

    const texto = document.querySelector(".x_minutos");
    let max = 10;
    let min = 2;
    let numeroRandom = Math.floor(Math.random() * (max - min) + min);

    function Minutos() {
        if (texto) {
            texto.innerHTML = numeroRandom;
            if (numeroRandom >= min && numeroRandom < max) {
                let maxSumar = 2;
                let minSumar = 1;
                numeroRandom += Math.floor(Math.random() * (maxSumar - minSumar) + minSumar);
            } else if (numeroRandom >= max) {
                let maxRestar = 3;
                let minRestar = 1;
                numeroRandom -= Math.floor(Math.random() * (maxRestar - minRestar) + minRestar);
            }
        }
    }

    (function actualizarMinutos() {
        Minutos();
        setTimeout(actualizarMinutos, 40000);
    })();

}